<!--
 * @Author: zyy
 * @Date: 2022-09-21 16:26:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-12 15:46:38
 * @Description: default
-->
<template>
    <div class="modal-box">
        <div class="order-info">
            <span class="mr-25">订单号:{{ info.order.order_sn }}</span>
            <span class="mr-25">下单时间:{{ $dateFormat("YYYY-MM-DD HH:mm:ss", new Date(info.order.createtime * 1000))
                }}</span>
            <!-- <span class="mr-25">订单来源:{{info.order.platform}}</span> -->
        </div>
        <a-card :hoverable="true">
            <div class="order-price">
                <div class="order-status">
                    <div class="status-title">{{ info.order.status_text }}</div>
                    <div class="status-text ">{{ info.order.status_desc }}</div>
                    <div class="status-text">备注:{{ info.order.remark }}</div>
                </div>
                <div class="price">
                    <div class="flex">
                        <span class="mr-20">商品总价:</span>
                        <span class="mr-20">¥{{ info.order.total_fee }}</span>
                    </div>
                    <div class="flex">
                        <span class="mr-20">配送费:</span>
                        <span class="mr-20">¥{{ info.order.dispatch_discount_money }}</span>
                    </div>
                    <div class="flex">
                        <span class="mr-20">优惠活动:</span>
                        <span class="mr-20">¥{{ info.order.coupon_fee }}</span>
                    </div>
                    <div class="flex">
                        <span class="mr-20">订单总金额:</span>
                        <span style="color: #fb8387;font-size: 20px;">¥{{ info.order.total_fee }}</span>
                    </div>
                </div>
            </div>
            <!-- <div style="padding:70px">
                <a-steps :current="info.order.status" @change="onChange" size="small">
                    <a-step title="买家下单" description="2022-12-12" />
                    <a-step title="买家付款" description="2022-12-12" />
                    <a-step title="商家发货" description="2022-12-12" />
                    <a-step title="交易完成" description="2022-12-12" />
                </a-steps>
            </div> -->
            <div class="hint">
                <div>
                    <span style="color: #FFB333;">温馨提示:</span>
                    <span>买家未在规定时间内付款，交易自动关闭</span>
                </div>
                <div>
                    <span style="color: #7438D5;">买家留言:</span>
                    <span>{{ info.order.memo || '暂无信息' }}</span>
                </div>
            </div>
        </a-card>
        <div style="margin-top: 20px;">
            <a-card :bodyStyle="{ 'background-color': '#f8f8f8' }" class="consignee-box">
                <div>
                    <span class="consignee-title">收货信息</span>
                    <span style="color: #fb8387;margin-left: 20px;cursor: pointer;" @click="copy">复制</span>
                </div>
                <div class="flex">
                    <span class="mr-20">收货人:</span>
                    <span>{{ info.order.consignee }}</span>
                </div>
                <div class="flex">
                    <span class="mr-20">联系电话:</span>
                    <span>{{ info.order.phone }}</span>
                </div>
                <div class="flex">
                    <span class="mr-20">省市区:</span>
                    <span>{{ `${info.order.province_name}${info.order.city_name}${info.order.area_name}` }}</span>
                </div>
                <div class="flex">
                    <span class="mr-20">收货地址:</span>
                    <span>{{ info.order.address }}</span>
                </div>
                <div class="flex" style="margin:20px 0">
                    <div style="width:300px">
                        <div class="consignee-title">付款信息</div>
                        <div>
                            <span>付款状态:</span>
                            <span>{{ info.order.status_text }}</span>
                        </div>
                    </div>
                    <div>
                        <div class="consignee-title">下单用户</div>
                        <div class="flex">
                            <div><img
                                    src="	https://cdn.tjsq.tjo2o.cn/attachments/images/202203/31/r9trRYN4SJZCLekrFJqGQl1LP33RhzLge9tYjgnA.jpeg"
                                    height="60" width="60"></div>
                            <div style="margin-left:20px;line-height: 20px;">
                                <div>ID:{{ info.order.user.id }}</div>
                                <div>昵称:{{ info.order.user.username }}</div>
                                <div>联系方式:{{ info.order.user.mobile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-card>
        </div>
        <div style="margin-top: 20px;" class="table-box">
            <a-table :columns="columns" :data-source="info.item" rowKey="id" :scroll="{ x: 950 }" :pagination="false">
                <span slot="goods" slot-scope="data">
                    <div class="flex">
                        <div><img :src="data.goods_image" alt="" height="40" width="40"></div>
                        <div style="margin-left:10px">
                            <div>{{ data.goods_title }}</div>
                            <div style="font-size: 12px;color:#686767;">规格:{{ data.goods_sku_text }}</div>
                        </div>
                    </div>
                </span>
            </a-table>
        </div>
    </div>
</template>
<script>
import { $dateFormat } from '@/plugins/utils.js'

export default {
    props: {
        info: {
            default: () => ({
                item: [],
                order: {}
            })
        }
    },
    data() {
        return {
            current: 0,
            columns: [
                {
                    title: "商品",
                    key: "goods",
                    scopedSlots: { customRender: "goods" },
                    width: 400
                },
                {
                    title: "单价(元)",
                    dataIndex: "goods_price",
                    key: "goods_price",
                    width: 100
                },
                {
                    title: "数量",
                    dataIndex: "goods_num",
                    key: "goods_num",
                    width: 100
                },
                {
                    title: "优惠",
                    key: "discount_fee",
                    dataIndex: "discount_fee",
                    width: 100
                },
                {
                    title: "小计(元)",
                    key: "pay_price",
                    dataIndex: "pay_price",
                    width: 100
                },
                // {
                //     title: "订单类型",
                //     key: "goods_type",
                //     dataIndex: "goods_type",
                //     width: 100
                // },
                // {
                //     title: "配送方式",
                //     key: "dispatch_type_text",
                //     dataIndex: "dispatch_type_text",
                //     width: 100
                // },
                {
                    title: "发货状态",
                    key: "dispatch_status_text",
                    dataIndex: "dispatch_status_text",
                    width: 100
                },
                // {
                //     title: "核销详情",
                //     key: "status",
                //     dataIndex: "goods_num",
                //     width: 100
                // },
                // {
                //     title: "退款状态",
                //     key: "refund_status_text",
                //     dataIndex: "refund_status_text",
                //     width: 100
                // },
                // {
                //     title: "售后状态",
                //     key: "aftersale_status_text",
                //     dataIndex: "aftersale_status_text",
                //     width: 100
                // },
                // {
                //     title: "所属门店",
                //     key: "store",
                //     dataIndex: "store",
                //     width: 100
                // },
                // {
                //     title: "评价状态",
                //     key: "comment_status_text",
                //     dataIndex: "comment_status_text",
                //     width: 100
                // },
            ],
            table: {
                loading: false,
                data: [],
            },
        }
    },
    methods: {
        copy() {
            // 收货人:促销信息;联系电话:18622398277;收货地址:北京市北京市东城区新促销信息
            let text = `收货人:${this.info.order.consignee};联系电话:${this.info.order.phone};收货地址:${this.info.order.province_name}${this.info.order.city_name}${this.info.order.area_name}${this.info.order.address};`
            navigator.clipboard.writeText(text).then(() => { });
        },
        onChange(current) {
            this.current = current;
        },
    }
}
</script>
<style scoped lang="less">
.modal-box {
    max-height: 600px;
    // width: 1000px;
    overflow: hidden;
    overflow-y: auto;
    // overflow-x: auto;
}

.table-box {
    // width: 950px;
    // overflow: hidden;
    // overflow-x: auto;
}

.consignee-box {
    color: #686767;
    font-size: 12px;
    line-height: 30px;

    .consignee-title {
        color: #000;
    }
}

.hint {
    width: 100%;
    padding-top: 20px;
    border-top: 1px solid #e3e3e3;
    margin-top: 15px;
    font-size: 12px;
    color: #686767;
    line-height: 30px;
}

.flex {
    display: flex;
}

.mr-25 {
    margin-right: 25px;
}

.mr-20 {

    margin-right: 20px;
    text-align-last: justify;
    width: 100px;
    display: block;
    line-height: 30px;
    height: 30px;
}

.order-info {
    height: 40px;
    line-height: 40px;
    color: #686767;
}

.order-price {
    display: flex;
    // padding: 10px;
}

.order-status {
    margin-right: 50px;

    .status-title {
        font-size: 24px;
        font-weight: 700;
        line-height: 70px;
    }

    .status-text {
        font-size: 12px;
        color: #8e8d8d;
        line-height: 30px;
        max-width: 360px;
    }
}

.price {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 13px;
}
</style>